import React from "react";

const LanguageContext = React.createContext({
    language: navigator.language,
    setLanguage: (language: string) => {}
});

export default LanguageContext;